import { Lock, LockOpen, Schedule, Warning } from '@sparkpost/matchbox-icons';
import React from 'react';
import { Tag, Tooltip } from 'src/components/matchbox';
import useUniqueId from 'src/hooks/useUniqueId';

const TLS_STATUS_CONFIG = {
  unavailable: {
    color: undefined,
    icon: LockOpen,
    label: 'Inactive'
  },
  pending: {
    color: 'blue',
    icon: Schedule,
    label: 'Pending'
  },
  valid: {
    color: 'green',
    icon: Lock,
    label: 'Valid'
  },
  expired: {
    color: 'yellow',
    icon: Warning,
    label: 'Expired'
  }
};

function getTooltipText(tlsStatus, usesManagedCertificate, verified) {
  switch (tlsStatus) {
    case 'unavailable':
      if (!verified) {
        return 'Verify the domain to enable a TLS certificate';
      }
      return 'TLS is unavailable for this domain at the moment';
    case 'pending':
      return 'Certificate issuance in progress. This may take several minutes';
    case 'valid':
      return 'This domain has a valid TLS certificate';
    case 'expired':
      return 'The TLS certificate could not be renewed automatically. Please make sure the DNS settings are in place and reverify the domain';
    default:
      return '';
  }
}

export default function TlsStatusBadge({ tlsStatus, usesManagedCertificate, verified }) {
  const tooltipId = useUniqueId('tls-status');
  const config = TLS_STATUS_CONFIG[tlsStatus];

  if (!config) {
    return null;
  }

  const Icon = config.icon;
  const tooltipText = getTooltipText(tlsStatus, usesManagedCertificate, verified);

  return (
    <Tooltip content={tooltipText} id={tooltipId} dark>
      <Tag color={config.color}>
        <Icon size={15} />
        <span> {config.label}</span>
      </Tag>
    </Tooltip>
  );
}
